import React from 'react';
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-[#082E5C] to-[#0a3a6e] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <img
                src="https://customer-assets.emergentagent.com/job_condodigitalchile/artifacts/ddn74r4e_Logo%20Tu%20Condominio%20Digital%20%281%29.png"
                alt="Tu Condominio Digital"
                className="h-16 w-16 object-contain"
              />
              <div>
                <h3 className="text-2xl font-bold">Tu Condominio Digital</h3>
                <p className="text-[#00D4D8] text-sm">La administración del futuro</p>
              </div>
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Transformamos la administración de condominios con tecnología de punta, inteligencia artificial y automatización. Todo en un solo click.
            </p>
            {/* Social Links */}
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 bg-white/10 hover:bg-[#00D4D8] rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/10 hover:bg-[#00D4D8] rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/10 hover:bg-[#00D4D8] rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-[#FFDA0C]">Enlaces Rápidos</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('servicios')}
                  className="text-gray-300 hover:text-[#00D4D8] transition-colors"
                >
                  Servicios
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('tecnologia')}
                  className="text-gray-300 hover:text-[#00D4D8] transition-colors"
                >
                  Tecnología
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('perfiles')}
                  className="text-gray-300 hover:text-[#00D4D8] transition-colors"
                >
                  Para Ti
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('nosotros')}
                  className="text-gray-300 hover:text-[#00D4D8] transition-colors"
                >
                  Nosotros
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contacto')}
                  className="text-gray-300 hover:text-[#00D4D8] transition-colors"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-[#FFDA0C]">Contacto</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Mail className="text-[#00D4D8] flex-shrink-0 mt-1" size={20} />
                <a
                  href="mailto:eduardo.briceno@tucondominiodigital.com"
                  className="text-gray-300 hover:text-[#00D4D8] transition-colors"
                >
                  eduardo.briceno@tucondominiodigital.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="text-[#00D4D8] flex-shrink-0 mt-1" size={20} />
                <a
                  href="tel:+56951081490"
                  className="text-gray-300 hover:text-[#00D4D8] transition-colors"
                >
                  +56 9 5108 1490
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="text-[#00D4D8] flex-shrink-0 mt-1" size={20} />
                <span className="text-gray-300">Santiago, Chile</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} Tu Condominio Digital. Todos los derechos reservados.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-[#00D4D8] transition-colors">
                Política de Privacidad
              </a>
              <a href="#" className="text-gray-400 hover:text-[#00D4D8] transition-colors">
                Términos y Condiciones
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
